<template>
  <tr class="profile-table__row">
    <td class="profile-table__cell">
      <div class="custom-control custom-checkbox ml-2">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="trainee.id"
          :value="trainee.id"
          v-model="selectedTrainees"
          @change="updateSelectAll"
        />
        <label :for="trainee.id" class="custom-control-label"></label>
      </div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">{{ trainee.id }}</div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">
        {{ traineeName }}
      </div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">
        {{ traineeFunction }}
      </div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">
        {{ traineeService }}
      </div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">{{ traineeLang }}</div>
    </td>
    <td class="profile-table__cell" @click.prevent.stop="showTraineeDetails">
      <div class="profile-table__item">{{ establishmentTitle }}</div>
    </td>
    <td class="profile-table__cell">
      <div class="profile-table__item" v-if="checkEditable">
        <button
          class="btn btn-primary btn-squared mr-1"
          @click.stop.prevent="showEditTraineesModal($event, trainee)"
        >
          <span class="icon icon-pen_white"></span>
        </button>
        <button class="btn btn-danger btn-squared" @click.stop.prevent="remove">
          <span class="icon icon-trash_white"></span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'TeamRow',
  props: ['trainee', 'index', 'isLast'],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapFields(['user', 'establishment']),
    ...mapFields([
      'trainees.trainees',
      'trainees.selectedTrainees',
      'trainees.filtredTrainee',
      'trainees.isFiltrSelected',
      'trainees.isAllTrainnesSelected',
    ]),
    checkEditable() {
      return Boolean(
        [2, 4, 6, 7, 8, 9].includes(this.clientType) &&
          this.$lodash.get(this.establishment, 'id', false)
      )
    },
    traineeName() {
      let firstname = this.$lodash.get(this.trainee, 'firstname', '')
      let lastname = this.$lodash.get(this.trainee, 'lastname', '')
      return lastname + ' ' + firstname
    },
    traineeFunction() {
      let tf = this.$lodash.get(this.trainee, 'function', '--')
      if (tf != null) {
        return tf
      } else return '--'
    },
    traineeService() {
      let tf = this.$lodash.get(this.trainee, 'service', '--')
      if (tf != null) {
        return tf
      } else return '--'
    },
    traineeLang() {
      let tl = this.$lodash.get(this.trainee, 'preferredLanguage', '--')
      if (tl != null) {
        return tl
      } else return '--'
    },
    establishmentTitle() {
      let et = this.$lodash.get(this.trainee, 'establishmentTitle', '--')
      if (et != null) {
        return et
      } else return '--'
    },
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
  },
  mounted() {
    // this.selectedTrainees = []
  },
  methods: {
    showTraineeDetails() {
      let a = {}
      a = { ...this.trainee }
      this.$router.push({ path: `/trainee/${a.id}` }).catch((err) => {
        console.log(err)
      })
    },
    updateSelectAll() {
      // if (this.selectedTrainees.length && this.selectedTrainees.length == this.filtredTrainee.length) {
      //   this.isAllTrainnesSelected = true;
      // } else {
      //   this.isAllTrainnesSelected = false;
      // }
    },
    showEditTraineesModal(event, trainee) {
      let data = {}
      data.trainee = trainee
      this.$bus.$emit('trainee-settings-modal.show', data)
    },
    remove() {
      let data = {}
      data.title = 'Confirmation'
      data.message = `${this.$t('deleteConfirmation')}
            <span class="text-nowrap">
              ${this.trainee.firstname + ' ' + this.trainee.lastname}
            </span>  ?`
      data.data = this.trainee
      data.event = 'delete-trainee-confirmation'
      data.next = this.destroy
      this.$bus.$emit('confirmation-modal.show', data)
    },
  },
}
</script>

<style scoped>
.profile-table__row:hover .profile-table__item {
  background-color: #e1f1ff;
}

.profile-table__cell {
  cursor: pointer;
}
</style>
